<!-- vue2模版 -->
<template>
  <div class="banner">
    <div v-html="content" />
  </div>
</template>
<script>
import { getCMSTitleBar } from '@/api/cms'
import { getQueryString } from '@/common/tools'
export default {
  name: 'Titlebar',
  data () {
    return {
      name: '',
      img: '',
      content: ''
    }
  },
  mounted () {
    const id = getQueryString('id')
    if (id) {
      this.getCMSTitleBar(id)
    }
  },
  methods: {
    async getCMSTitleBar (id) {
      try {
        const { data } = await getCMSTitleBar({ id })
        this.name = data.title
        // 修改页面标签title
        document.title = data.title || '搜机网'
        this.img = data.img
        this.content = data.content
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style scoped lang="scss">

</style>
